"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getComponent = _interopRequireDefault(require("../../../utils/getComponent"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _ResponsiveTwoThirdsSplit = require("./ResponsiveTwoThirdsSplit.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ResponsiveTwoThirdsSplit = function ResponsiveTwoThirdsSplit(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  var leftContent = (0, _getComponent.default)('leftContent', children);
  var rightContent = (0, _getComponent.default)('rightContent', children);
  return /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.Wrapper, _extends({
    className: className
  }, props), leftContent && /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.LeftContent, {
    selfAlignment: leftContent.length && leftContent[0].props.selfAlignment
  }, leftContent) || /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.LeftContent, null), /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.Spacer, null), rightContent && /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.RightContent, {
    selfAlignment: rightContent.length && rightContent[0].props.selfAlignment
  }, rightContent) || /*#__PURE__*/_react.default.createElement(_ResponsiveTwoThirdsSplit.RightContent, null));
};

ResponsiveTwoThirdsSplit.propTypes = {
  /** children, identified by `childkey="<leftContent|rightContent>"` */
  children: _propTypes2.default.children,

  /** standard className hook */
  className: _propTypes.default.string
};
ResponsiveTwoThirdsSplit.defaultProps = {
  children: undefined,
  className: ''
};
var _default = ResponsiveTwoThirdsSplit;
exports.default = _default;